import { __rest as y, __assign as o, __spreadArray as f } from "./index93.mjs";
import { parse as b } from "./index94.mjs";
import { memoize as d, strategies as g } from "./index95.mjs";
import { PART_TYPE as L, formatToParts as F } from "./index96.mjs";
function T(e, r) {
  return r ? o(o(o({}, e || {}), r || {}), Object.keys(e).reduce(function(t, n) {
    return t[n] = o(o({}, e[n]), r[n] || {}), t;
  }, {})) : e;
}
function I(e, r) {
  return r ? Object.keys(e).reduce(function(t, n) {
    return t[n] = T(e[n], r[n]), t;
  }, o({}, e)) : e;
}
function h(e) {
  return {
    create: function() {
      return {
        get: function(r) {
          return e[r];
        },
        set: function(r, t) {
          e[r] = t;
        }
      };
    }
  };
}
function w(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: d(function() {
      for (var r, t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return new ((r = Intl.NumberFormat).bind.apply(r, f([void 0], t, !1)))();
    }, {
      cache: h(e.number),
      strategy: g.variadic
    }),
    getDateTimeFormat: d(function() {
      for (var r, t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return new ((r = Intl.DateTimeFormat).bind.apply(r, f([void 0], t, !1)))();
    }, {
      cache: h(e.dateTime),
      strategy: g.variadic
    }),
    getPluralRules: d(function() {
      for (var r, t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return new ((r = Intl.PluralRules).bind.apply(r, f([void 0], t, !1)))();
    }, {
      cache: h(e.pluralRules),
      strategy: g.variadic
    })
  };
}
var N = (
  /** @class */
  (function() {
    function e(r, t, n, s) {
      var a = this;
      if (t === void 0 && (t = e.defaultLocale), this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(u) {
        var m = a.formatToParts(u);
        if (m.length === 1)
          return m[0].value;
        var l = m.reduce(function(i, c) {
          return !i.length || c.type !== L.literal || typeof i[i.length - 1] != "string" ? i.push(c.value) : i[i.length - 1] += c.value, i;
        }, []);
        return l.length <= 1 ? l[0] || "" : l;
      }, this.formatToParts = function(u) {
        return F(a.ast, a.locales, a.formatters, a.formats, u, void 0, a.message);
      }, this.resolvedOptions = function() {
        var u;
        return {
          locale: ((u = a.resolvedLocale) === null || u === void 0 ? void 0 : u.toString()) || Intl.NumberFormat.supportedLocalesOf(a.locales)[0]
        };
      }, this.getAst = function() {
        return a.ast;
      }, this.locales = t, this.resolvedLocale = e.resolveLocale(t), typeof r == "string") {
        if (this.message = r, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var p = s || {};
        p.formatters;
        var v = y(p, ["formatters"]);
        this.ast = e.__parse(r, o(o({}, v), { locale: this.resolvedLocale }));
      } else
        this.ast = r;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = I(e.formats, n), this.formatters = s && s.formatters || w(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(r) {
      if (!(typeof Intl.Locale > "u")) {
        var t = Intl.NumberFormat.supportedLocalesOf(r);
        return t.length > 0 ? new Intl.Locale(t[0]) : new Intl.Locale(typeof r == "string" ? r : r[0]);
      }
    }, e.__parse = b, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  })()
);
export {
  N as IntlMessageFormat
};
